import { render, staticRenderFns } from "./LaserPoint.vue?vue&type=template&id=544a3488"
import script from "./LaserPoint.vue?vue&type=script&lang=js"
export * from "./LaserPoint.vue?vue&type=script&lang=js"
import style0 from "./LaserPoint.vue?vue&type=style&index=0&id=544a3488&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports